import LanguageContext from "components/LanguageContext";
import { useFindPages } from "hooks/page.hook";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { numericFormatDate } from "utils/commonUtils";
import t from "utils/locales/translation.json";

const DateToDisplay = (props) => {
  const { pageVersion = {} } = props;
  const { page = {}, pageId } = pageVersion || {};
  const { originalPageId, siteId, lang, firstPublishedDate } = page || {};

  const { language } = useContext(LanguageContext);

  const { data: frenchPnuPages = [] } = useFindPages({
    siteId,
    pageId: lang === "FR" ? pageId : originalPageId,
    filters: [`page.lang||eq||FR`],
  });

  const { firstPublishedDate: frenchPublishDate } = frenchPnuPages[0] || {};

  const date = lang === "FR" ? firstPublishedDate : frenchPublishDate || firstPublishedDate;

  return (
    <p className="fr-card__detail fr-icon-calendar-event-fill">
      {t[language].common.news.published_label} {numericFormatDate({ date, lang })}
    </p>
  );
};

DateToDisplay.propTypes = {
  pageVersion: PropTypes.shape(),
};

export default DateToDisplay;
